import { Action, initialState, State } from 'store/store';

export const updateLandingPageSeenState = (
  state: State = initialState,
  { data }: Action
): State => {
  const { landingPagesSeenState = {} } = state;
  const { parentId, childIndex, clear } = data;

  if (!landingPagesSeenState[parentId]) {
    landingPagesSeenState[parentId] = [];
  }

  const updatedLandingPagesSeenState = {
    ...landingPagesSeenState,
    [parentId]: clear
      ? [childIndex]
      : Array.from(new Set([...landingPagesSeenState[parentId], childIndex])),
  };

  return {
    ...state,
    landingPagesSeenState: updatedLandingPagesSeenState,
  };
};
